"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ActorAbstractMediaTyped_1 = require("./ActorAbstractMediaTyped");

var ActorAbstractMediaTypedFixed =
/*#__PURE__*/
function (_ActorAbstractMediaTy) {
  _inherits(ActorAbstractMediaTypedFixed, _ActorAbstractMediaTy);

  function ActorAbstractMediaTypedFixed(args) {
    var _this;

    _classCallCheck(this, ActorAbstractMediaTypedFixed);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ActorAbstractMediaTypedFixed).call(this, args));
    var scale = _this.priorityScale || _this.priorityScale === 0 ? _this.priorityScale : 1;
    _this.mediaTypes = require('lodash.mapvalues')(_this.mediaTypes, function (priority) {
      return priority * scale;
    });
    _this.mediaTypes = Object.freeze(_this.mediaTypes);
    return _this;
  }

  _createClass(ActorAbstractMediaTypedFixed, [{
    key: "testHandle",
    value: function () {
      var _testHandle = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(action, mediaType, context) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (mediaType in this.mediaTypes) {
                  _context.next = 2;
                  break;
                }

                throw new Error('Unrecognized media type: ' + mediaType);

              case 2:
                _context.next = 4;
                return this.testHandleChecked(action, context);

              case 4:
                return _context.abrupt("return", _context.sent);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function testHandle(_x, _x2, _x3) {
        return _testHandle.apply(this, arguments);
      }

      return testHandle;
    }()
  }, {
    key: "testMediaType",
    value: function () {
      var _testMediaType = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(context) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", true);

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function testMediaType(_x4) {
        return _testMediaType.apply(this, arguments);
      }

      return testMediaType;
    }()
  }, {
    key: "getMediaTypes",
    value: function () {
      var _getMediaTypes = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(context) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", this.mediaTypes);

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getMediaTypes(_x5) {
        return _getMediaTypes.apply(this, arguments);
      }

      return getMediaTypes;
    }()
  }]);

  return ActorAbstractMediaTypedFixed;
}(ActorAbstractMediaTyped_1.ActorAbstractMediaTyped);

exports.ActorAbstractMediaTypedFixed = ActorAbstractMediaTypedFixed;